module.exports = __webpack_public_path__ + "static/media/agEUR.7fc75cdb.png";